import { CARD_ENROLL_EVENTS } from '../constants/common-enums';

/** To check user account is locked in the system based on BE response
 * @param {object} responseData
 * @returns {boolean}
 */
const isLockedUser = responseData => {
  return responseData?.maskedConsumer?.status === CARD_ENROLL_EVENTS.LOCKED;
};

export default isLockedUser;
